/**
 * Helpers de duracao padrao de contagem.
 *
 * Duracao PADRAO = 29 minutos (decisao do key user; era 59).
 * Hora Final sugerida = Hora Inicial + 29min (ex.: 14:00 -> 14:29). E apenas
 * um DEFAULT/sugestao — o usuario pode alterar a Hora Final manualmente.
 * Espelha o backend (inventory/utils/duracao.py DURACAO_PADRAO_MINUTOS).
 *
 * NOTA: o nome computeHoraFim59min e legado; o valor vem da constante abaixo.
 */

export const DURACAO_PADRAO_MINUTOS = 29;

/**
 * Retorna hora_inicio + DURACAO_PADRAO_MINUTOS (29 min) no formato HH:MM.
 * Cap em 23:59 se ultrapassar (edge case improvavel).
 *
 * @example
 *   computeHoraFim59min('08:00') // '08:29'
 *   computeHoraFim59min('23:45') // '23:59' (cap)
 *   computeHoraFim59min('')      // ''
 */
export function computeHoraFim59min(horaInicio: string | null | undefined): string {
  if (!horaInicio) return '';

  const parts = horaInicio.split(':');
  if (parts.length < 2) return '';

  const h = parseInt(parts[0], 10);
  const m = parseInt(parts[1], 10);
  if (isNaN(h) || isNaN(m)) return '';

  const totalMin = h * 60 + m + DURACAO_PADRAO_MINUTOS;
  let finalH = Math.floor(totalMin / 60);
  let finalM = totalMin % 60;

  // Cap em 23:59 (edge case de contagem perto da meia-noite)
  if (finalH >= 24) {
    finalH = 23;
    finalM = 59;
  }

  return `${String(finalH).padStart(2, '0')}:${String(finalM).padStart(2, '0')}`;
}
